import { pantryColors, pantryTypography } from '@pantry/ui'
import React from 'react'
import {
  PANTRY_STORE_PERMISSIONS,
  PERMISSION_LABELS,
  type PermissionId,
} from '../../permissions'
import { Checkbox } from './styleHelpers'

const p = pantryColors
const F = pantryTypography.fontFamily

interface PermissionGroupProps {
  keys: PermissionId[]
  selected: Record<string, boolean>
  onToggleOne: (key: string, checked: boolean) => void
}

const PermissionGroup: React.FC<PermissionGroupProps> = ({
  keys,
  selected,
  onToggleOne,
}) => (
  <div
    style={{
      background: p.gray[50],
      borderRadius: 6,
      padding: '10px 12px',
      marginBottom: 8,
    }}
  >
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr',
        gap: '4px 12px',
      }}
    >
      {keys.map((key) => (
        <Checkbox
          key={key}
          checked={!!selected[key]}
          onChange={(checked) => onToggleOne(key, checked)}
          label={PERMISSION_LABELS[key] ?? key}
        />
      ))}
    </div>
  </div>
)

export interface PermissionGridProps {
  selected: Record<string, boolean>
  errorMsg?: string
  onToggleOne: (key: string, checked: boolean) => void
}

export const PermissionGrid: React.FC<PermissionGridProps> = ({
  selected,
  errorMsg,
  onToggleOne,
}) => (
  <div>
    <div
      style={{
        fontSize: 12,
        color: p.gray[400],
        marginBottom: 6,
        fontFamily: F,
      }}
    >
      Permission to access:
    </div>
    <PermissionGroup
      keys={PANTRY_STORE_PERMISSIONS}
      selected={selected}
      onToggleOne={onToggleOne}
    />
    {errorMsg ? (
      <div
        style={{
          fontSize: 12,
          color: '#DC2626',
          marginTop: 4,
          fontFamily: F,
        }}
      >
        {errorMsg}
      </div>
    ) : null}
  </div>
)
